import "../assets/scss/components/_country-delivery.scss";
import type { CountryDeliveryProps } from "../types/components/CountryDeliveryProps";

export const CountryDelivery = ({ availableCountries = {} }: CountryDeliveryProps) => {
	const isUk = Object.keys(availableCountries).includes("79");

	return !isUk && Object.keys(availableCountries).length > 0 ? (
		<div className="country-delivery">
			<span className="country-name">{availableCountries[Object.keys(availableCountries)[0]]}&nbsp;</span>{" "}
			Delivery Only
		</div>
	) : null;
};

export default CountryDelivery;
